import { useEffect, useState } from 'react';

export const fallbackPricing = {
  maintenancePrice: 140,
  vehicleSizes: [
    { id: 'small', label: 'Small / Standard Vehicle', price: 130 },
    { id: 'large', label: 'Large SUV / Large Vehicle', price: 150 },
    { id: 'ute', label: 'Large 4WD / Ute / Pick-up', price: 160 },
  ],
  conditions: [
    { id: 'normal', label: 'Normal', price: 0 },
    { id: 'very_dirty', label: 'Very Dirty', price: 20 },
    { id: 'extremely_dirty', label: 'Extremely Dirty', price: 30 },
  ],
  seatCleaning: [
    { id: 'wipe', label: 'Just Wiping', price: 0 },
    { id: 'leather', label: 'Leather Cleaning & Conditioner', price: 30 },
    { id: 'fabric', label: 'Fabric Deep Extraction', price: 40 },
  ],
  paintProtection: [
    { id: 'none', label: 'None', price: 0 },
    { id: 'three_month', label: '3-Month Paint Protection', price: 40 },
    { id: 'ceramic', label: '1-Year Ceramic Coating', price: 550 },
  ],
  additionalServices: [
    { id: 'polish', label: 'Scratch & Spot Polish', price: 40, from: true },
    { id: 'pet_hair', label: 'Pet Hair Removal', price: 20, from: true },
    { id: 'headlights', label: 'Headlight Restoration', price: 50, from: false },
  ],
};

// Pricing loads from /pricing.json (editable without touching code); falls back to the values above.
export function usePricing() {
  const [pricing, setPricing] = useState(fallbackPricing);
  useEffect(() => {
    let active = true;
    fetch('/pricing.json')
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => { if (active && data && data.vehicleSizes) setPricing(data); })
      .catch(() => {});
    return () => { active = false; };
  }, []);
  return pricing;
}

export const priceOf = (list, id) => list.find((item) => item.id === id)?.price || 0;
